<template>
  <div class="space-y-1 p-2">
    <div
      v-for="contact in contacts"
      :key="contact.id"
      @click="$emit('select-contact', contact)"
      class="flex items-center gap-3 p-3 rounded-lg cursor-pointer transition-all duration-200 hover:bg-gray-50"
      :class="{ 'bg-blue-50 border border-blue-100': selectedContact && selectedContact.id === contact.id }"
    >
      <!-- Avatar -->
      <div class="relative flex-shrink-0">
        <div class="flex-shrink-0 h-12 w-12">
          <UserAvatar 
            :src="getValidAvatarUrl(contact.avatar)" 
            :name="contact.name" 
            size="lg"
          />
        </div>
        <!-- Online Status Indicator -->
        <div 
          class="absolute -bottom-1 -right-1 w-4 h-4 rounded-full border-2 border-white"
          :class="contact.isOnline ? 'bg-green-500' : 'bg-gray-400'"
        ></div>
      </div>

      <!-- Contact Info -->
      <div class="flex-1 min-w-0">
        <div class="flex items-center justify-between mb-1">
          <h3 
            class="text-sm truncate"
            :class="contact.unreadCount > 0 ? 'font-extrabold text-gray-900' : 'font-normal text-gray-900'"
          >
            {{ contact.name }}
          </h3>
          <span class="text-xs text-gray-500">{{ contact.lastMessageTime }}</span>
        </div>
        <p 
          class="text-xs truncate"
          :class="contact.unreadCount > 0 ? 'font-bold text-gray-700' : 'font-normal text-gray-500'"
        >
          {{ contact.lastMessage }}
        </p>
      </div>

      <!-- Unread Count Badge -->
      <div v-if="contact.unreadCount > 0" class="flex-shrink-0">
        <span class="inline-flex items-center justify-center w-5 h-5 text-xs font-medium text-white bg-blue-600 rounded-full">
          {{ contact.unreadCount > 9 ? '9+' : contact.unreadCount }}
        </span>
      </div>
    </div>

    <!-- Empty State -->
    <div v-if="contacts.length === 0" class="text-center py-8">
      <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
      <h3 class="mt-2 text-sm font-medium text-gray-900">No chats found</h3>
      <p class="mt-1 text-sm text-gray-500">Try adjusting your search criteria.</p>
    </div>
  </div>
</template>

<script>
import UserAvatar from '@/components/UserAvatar.vue'

export default {
  name: 'ContactList',
  components: {
    UserAvatar
  },
  props: {
    contacts: {
      type: Array,
      required: true
    },
    selectedContact: {
      type: Object,
      default: null
    }
  },
  emits: ['select-contact'],
  setup() {
    // Helper function to validate avatar URLs
    const getValidAvatarUrl = (avatarUrl) => {
      if (!avatarUrl) return null
      if (avatarUrl === '/images/default-avatar.png') return null
      if (avatarUrl === '') return null
      // Allow any non-empty string that's not the default avatar
      return avatarUrl
    }
    
    return {
      getValidAvatarUrl
    }
  }
}
</script>
